import {
  Flex,
  IconButton,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { useSidebarDrawer } from '../../hooks/sidebarDrawer';

import { Logo } from './Logo';
import { NotificationsNav } from './NotificationsNav';
import { Profile } from './Profile';
import { SearchBox } from './SearchBox';

export function Header() {
  const { onOpen } = useSidebarDrawer();

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const bg = useColorModeValue('blue.600', 'gray.800');

  return (
    <Flex borderBottomWidth="1px" bg={bg} zIndex="banner">
      <Flex as="header" w="100%" h="16" mx="auto" px={[4, 6]} align="center">
        {!isWideVersion && (
          <IconButton
            aria-label="Navegação"
            fontSize={[18, 22]}
            variant="unstyled"
            onClick={onOpen}
            mr="2"
          />
        )}
        <Logo />

        {isWideVersion && <SearchBox />}

        <Flex align="center" ml="auto">
          <NotificationsNav />
          <Profile />
        </Flex>
      </Flex>
    </Flex>
  );
}
